import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const Modifierforation = () => {
  const { id } = useParams();


  return (
    <>
      <h1>Modifie la formation</h1>
    </>
  );
};

export default Modifierforation;
